import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 482px;

  #drop_zone {
    border: 1px dashed #c1b2fa;
    width: 100%;
    height: 160px;
    /* background-color: #f3f0ff; */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border-radius: 8px;
  }

  .upload-drag-title {
    color: #7a5fec;
    font-size: 16px;
    font-weight: bold;
    margin-top: 12px;
  }

  .container-list-files {
    display: flex;
    gap: 20px;
    flex-direction: column;
    position: relative;
  }

  .content-card-list-files:first-child {
    margin-top: 20px;
  }

  .content-file {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .content-card-list-files {
    display: grid;
    align-items: center;
    /* justify-content: flex-end; */
    grid-template-columns: 1fr;
    width: 100%;
    height: 72px;
    padding: 8px;
    gap: 12px;
    /* box-shadow: 0px 4px 16px #eae2fd; */
    /* border-radius: 8px; */
    background: #ffffff;
    position: relative;
    /* animation-name: example; */
    /* animation-duration: 400ms; */
  }

  .file-title {
    line-height: 130%;
  }

  .file-size {
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 12px;
    line-height: 130%;
  }

  .file-progress {
    width: 100%;
    height: 8px;
    display: grid;
    grid-template-columns: 1fr 32px;
    align-items: start;
    justify-items: center;
    gap: 20px;
  }

  .bar-progress {
    height: 8px;
    width: 100%;
    border-radius: 999px;
    background-color: #e3e3ed;
    overflow: hidden;
  }

  .file-progress-bg {
    background-color: #ac96e4;
    height: 100%;
    transition: all ease-in 40ms;
    /* transition-delay: 40ms; */
  }

  .file-progress-bg.in_progress {
    background-color: #ac96e4;
  }

  .file-progress-bg.finish_progress {
    background-color: #73b172;
  }

  .file-progress-bg.failed_progress {
    background-color: #e36363;
  }

  .count-progress {
    font-size: 12px;
    margin-top: -5px;
  }

  .handle-action-upload {
    position: absolute;
    top: 15px;
    right: 15px;
  }

  /* @keyframes example {
    from {
      position: absolute;
      margin-top: -60px;
    }

    to {
      position: absolute;
      margin-top: 20px;
    }
  } */
`;

export const WrapperInputFile = styled.div``;
export const DropPlusIcon = styled.img`
  cursor: pointer;
`;
export const DragDrop = styled.div`
  border-radius: 10px;
  border: 1px solid #9d9d9d;

  display: flex;
  gap: 0 16px;
  align-items: center;
  justify-content: center;
  padding: 20px 50px;
`;
